module.exports = __webpack_public_path__ + "static/media/1615226073281.761dc168.jpeg";